import React from 'react';
import { Link } from 'react-router-dom';
import work2 from '../../../assets/p2.png'
const Project2 = () => {
    const projectsData =
    {
        id: 1,
        image: work2,
        title: "BuySellRepeat",
        description: "Full-Stack MERN Projects",
        link: "https://assignment-12-9aa5e.web.app/",
        go: "/project1"
    };
    return (
        <div className='mt-[70px]'>

            <h1 className='text-center text-5xl font-bold mb-10'>Welcome to my project</h1>
            <div className=''>
                <img className='w-1/2 mx-auto' src={projectsData.image} alt="" />
            </div>
            <div className='w-1/2 mx-auto mt-10 flex justify-between'>
                <Link to='/project1' className='btn btn-warning'>Previous project</Link>
                <Link to='/project3' className='btn btn-warning'>Next project</Link>
            </div>
            <div className='w-1/2 mx-auto mt-10'>
                <h2 className='text-3xl text-info'>Rate Us- A online Photography Review website</h2>
            </div>
            <div className='w-1/2 mx-auto mt-10'>
                <h2>Built with: React, Tailwind, Express.JS, NodeJS, MongoDB.</h2>
            </div>
            <div className='w-1/2 mx-auto mt-10'>
                <h2>Feature included: Firebase Authentication, Private route,react-router, CRUD operation, react-photo-view, Blog page, env variable and JWT token for ensure more security vercel for server deploy. </h2>
            </div>
            <div className='w-1/2 mx-auto mt-10'>
                <h2>Key Features:
                    <br />
                    1. This web site is containing various review of different Photographer services with user reviews.

                    <br /><br />
                    2. On this site client can purchase a service and also can add his own Photography related service.
                    <br /><br />
                    3. User can post, edit and Delete his review also used Crud operations, SPA, react-router-Dom, Firebase Authentication.
                </h2>
            </div>
            <div className='w-1/2 mx-auto mt-10'>
                <a className='button' target='_blank' rel="noopener noreferrer" href="https://github.com/RAZYANIK/RateUs-client-repo">Client site Git Link</a>
                <a className='button ml-10' href="https://github.com/RAZYANIK/RateUs-server-site-repo" target='_blank' rel="noopener noreferrer">Server site Git Link</a>
            </div>
        </div>
    );
};

export default Project2;